import type {WebTrackingResponse} from '../types/webState'

const webStateAuthFeedbackMock: WebTrackingResponse = {
  state: {
    context: {
      display_targets: ['multiorder'],
      is_performer_position_available: false,
      performer_search: {
        is_in_progress: false,
      },
      provider_status: 'delivered_finish',
      provider_tariff_class: 'sdd_long',
      role: 'initiator',
    },
    summary: 'Доставлено',
    description: 'жёлтый BMW 7er',
    sorted_route_points: [
      {
        point_id: '26388290220843',
        visit_status: 'visited',
        type: 'source',
        uri: 'ymapsbm1://geo?data=Cgg1NjcxNjcyMRJV0KDQvtGB0YHQuNGPLCDQnNC-0YHQutCy0LAsINC_0YDQvtC10LfQtCDQktC-0YHQutGA0LXRgdC10L3RgdC60LjQtSDQktC-0YDQvtGC0LAsIDHQkCIKDex4FkIVwgVfQg,,',
        coordinates: [37.6177, 55.755863],
        full_text: 'проезд Воскресенские Ворота, 1А',
        short_text: 'проезд Воскресенские Ворота, 1А',
        area_description: 'Москва',
        contact: {
          phone: '+7********40',
        },
      },
      {
        point_id: '26388290220844',
        visit_status: 'visited',
        type: 'destination',
        uri: 'ymapsbm1://org?oid=214618955344',
        coordinates: [37.62327318, 55.7540552],
        full_text: 'Столовая № 57',
        short_text: 'Столовая № 57',
        area_description: 'Москва',
        contact: {
          phone: '+7********13',
        },
      },
    ],
    active_route_points: [],
    performer: {
      name: 'Martinez Jose',
      short_name: 'Jose',
      vehicle_model: 'BMW 7er',
      vehicle_number: 'Т277ВК34',
      rating: '5.0',
      phone: '',
      image_tag_default: 'delivery_default_courier',
    },
    content_sections: [
      {
        id: '71f3610b6d8a446a899fb35835a6e70d',
        items: [
          {
            id: 'a0a16eaf889c4ca2a2a4a78a7fd702d4',
            title: {
              text: 'От двери до двери',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            trail_text: {
              text: 'Включено',
              typography: 'body2',
              color: 'TextMinor',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_door_to_door',
            },
            type: 'list_item',
          },
        ],
      },
      {
        id: 'fcad839a3cdb4d00bfde7343e8e41463',
        items: [
          {
            id: 'f3801337908c48678607dea4df962881',
            title: {
              text: 'Детали заказа',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_info',
            },
            sections: [
              {
                items: [
                  {
                    title: 'Тариф 2–4 часа',
                    subtitle: 'Вт 26 мая 13:57',
                    type: 'subtitle',
                  },
                  {
                    title: 'От двери до двери',
                    subtitle: 'Включено',
                    type: 'subtitle',
                  },
                  {
                    title: '135 ₽',
                    subtitle: 'Стоимость',
                    type: 'subtitle',
                  },
                ],
              },
              {
                title: 'Исполнитель',
                items: [
                  {
                    title: 'Martinez Jose',
                    subtitle: 'жёлтый BMW 7er, номер Т277ВК34',
                    trail_payload: {
                      buffer: 'Martinez Jose, жёлтый BMW 7er, номер Т277ВК34',
                      in_app_notification_text: 'Информация о курьере скопирована',
                      type: 'copy-payload',
                    },
                    type: 'subtitle',
                  },
                  {
                    title: 'Вадим Данилов Cargocheck',
                    type: 'subtitle',
                  },
                  {
                    title: 'Дополнительно о партнёре',
                    items: [
                      {
                        title: 'Льва Толстого 16',
                        type: 'subtitle',
                      },
                      {
                        title: 'Часы работы: 9:00-18:00',
                        type: 'subtitle',
                      },
                    ],
                    type: 'accordion',
                  },
                ],
              },
            ],
            metrica_label: 'Delivery.Tracking.Item.Details',
            type: 'details',
          },
          {
            id: '6203be9980ec4f0389c12f0d743583ef',
            title: {
              text: 'Получатель',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            type: 'header',
          },
          {
            id: '4193766cde52427cbddb295d0539e405',
            title: {
              text: 'Телефон для связи',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            subtitle: {
              text: '+7********13',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
              ignore_rtl: true,
            },
            lead_icon: {
              image_tag: 'delivery_phone',
            },
            type: 'list_item',
          },
          {
            id: '2d5a31df4ed8468e9b6bbb399d410b0c',
            type: 'separator',
          },
          {
            id: '07e0bc68585a4055a0cc8917a36d5b3c',
            title: {
              text: 'Столовая № 57',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_point',
            },
            metrica_label: 'Delivery.Tracking.Item.Point.Destination',
            type: 'list_item',
          },
        ],
      },
    ],
    primary_actions: [
      {
        type: 'feedback',
        title: 'Как вам заказ?',
        subtitles: [
          {
            scores: [1, 2, 3],
            title: 'Что вас разочаровало?',
          },
          {
            scores: [4],
            title: 'Что испортило впечатление?',
          },
          {
            scores: [5],
            title: 'Что вам особенно понравилось?',
          },
        ],
        reasons: [
          {
            reason_id: 'not_door_to_door',
            title: 'Курьер забрал/отдал заказ не у двери',
            scores: [1, 2, 3],
          },
          {
            reason_id: 'extra_funds',
            title: 'Курьер просил доплатить',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'impolite',
            title: 'Курьер был невежлив',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'damaged_package',
            title: 'Курьер повредил посылку',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'no_delivery',
            title: 'Курьер не доставил посылку',
            scores: [1, 2, 3],
          },
          {
            reason_id: 'another_courier_arrived',
            title: 'На фото другой курьер или машина',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'long_delivery',
            title: 'Пришлось долго ждать',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'unable_to_contact',
            title: 'Не удалось связаться с курьером',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'language_problem',
            title: 'Мы с курьером друг друга не поняли',
            scores: [1, 2, 3, 4],
          },
          {
            reason_id: 'fast_delivery',
            title: 'Быстрее ветра',
            scores: [5],
            icon: {
              active: 'delivery_fast_delivery_active_icon',
              inactive: 'delivery_fast_delivery_inactive_icon',
            },
          },
          {
            reason_id: 'polite_courier',
            title: 'Вежливый курьер',
            scores: [5],
            icon: {
              active: 'delivery_polite_courier_active_icon',
              inactive: 'delivery_polite_courier_inactive_icon',
            },
          },
          {
            reason_id: 'perfect',
            title: 'Всё как надо',
            scores: [5],
            icon: {
              active: 'delivery_perfect_active_icon',
              inactive: 'delivery_perfect_inactive_icon',
            },
          },
          {
            reason_id: 'above_expectations',
            title: 'Выше всех похвал',
            scores: [5],
            icon: {
              active: 'delivery_above_expectations_active_icon',
              inactive: 'delivery_above_expectations_inactive_icon',
            },
          },
        ],
        last_feedback: {
          score: 1,
          comment: '',
          reason_ids: ['another_courier_arrived'],
        },
      },
    ],
    secondary_actions: [
      {
        type: 'performer_call',
        title: 'Звонок курьеру',
        communication_method: {
          forwarding_id: 'performer',
          type: 'voice_forwarding_call',
        },
        metrica_label: 'Delivery.Tracking.Action.PerformerCall',
      },
      {
        type: 'open_yandex_messenger_support_chat',
        title: 'Помощь',
        messenger_data: {
          payload: {
            entrypoint: 'delivery:taxi_logictic_users_сorp2',
            order_id: '019e63ee514a82289cc452db18117503',
            user_phone_id: '',
            user_id: '',
          },
        },
      },
    ],
    meta: {},
  },
}

export default webStateAuthFeedbackMock
